/**
 * Resolve the plugin API base URL.
 *
 * The plugin runs embedded on the host PMS page (e.g. app.feegow.com), so a
 * page-relative "/api" resolves against the PMS origin, whose edge routing
 * does not forward every API path (only /api/session/* reaches the plugin
 * API from there). The front and the API are always served from the same
 * origin (see k8s-argocd-apps feegow-ai-assistant-plugin-v2-* values: front
 * at "/", API at "/api"), so the API base is derived from the origin the
 * plugin script itself was loaded from - the same mechanism the entry uses
 * for __webpack_public_path__.
 *
 * Resolution order:
 * 1. VUE_APP_API_URL - build-time override, only defined in local dev .env
 * 2. <script origin>/api - production/staging (ai-assistant-v2[.staging].feegow.com/api)
 * 3. "/api" - last resort, same fallback as FetchApi
 */
const scriptOrigin = (() => {
  try {
    const src = (document.currentScript as HTMLScriptElement | null)?.src;
    return src ? new URL(src).origin : "";
  } catch {
    return "";
  }
})();

export const API_BASE_URL: string =
  process.env.VUE_APP_API_URL || (scriptOrigin ? `${scriptOrigin}/api` : "/api");
